import React, { useState } from "react";
import TablaCotizaciones from "../../components/cotizaciones/TablaCotizaciones";
import { FaPlus } from "react-icons/fa";
import NuevaCotizacionDialog from "../../components/dialogs/NuevaCotizacionDialog";
import { useSelector } from "react-redux";
import ChartPricesCotizaciones from "../../components/cotizaciones/ChartPricesCotizaciones";
import MetaIndividualComercial from "../../components/metaComercial/MetaIndividualComercial";

const Cotizaciones = () => {
  const user = useSelector((state) => state.auth.user);

  return (
    <>
      <TablaCotizaciones userRedux={user} />
      <hr className="shadow-lg "/>
      {user && (
          user?.puesto?.toUpperCase() === "JEFE COMERCIAL" ||
          user?.puesto?.toUpperCase() === "GERENTE GENERAL" || 
          user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" || 
          user?.puesto?.toUpperCase() === "ASISTENTE"
        ) && (
          <MetaIndividualComercial />
        )}
    </>
  );
};

export default Cotizaciones;
